package com.neurobs.ccabserver.administrator.contexts

import com.neurobs.js.view.{Gui, NullGui}
import com.neurobs.react.ContextBase

object GuiContext extends ContextBase[Gui] {
	override protected def defaultStateValue(): Gui = new NullGui

}
